<template>
  <div class="select">
    <van-field
      :label="labeltext"
    
      :v-model="fieldId"
      :value="value"
      readonly
      clickable
      right-icon="arrow"
      :rules="rules"
      :left-icon="leftIcon"
      :placeholder="placeholder"
      @click="showPopup"
      :error-message="errorMessage"
    />
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '90%', width: '100%' }"
      get-container="#app"
    >
      <div class="selectSearch">
        <div class="header_param">
          <div class="left" @click="headBack()">
            <p class="backArrow"></p>
          </div>
          <!-- <p class="center">{{ labeltext }}</p>
          国家/地区 -->
           <p class="center">国家/地区</p>
          <div class="right"></div>
        </div>

        <van-search
          class="searchInput"
          placeholder="请输入搜索关键词"
          v-model="param"
          maxlength="10"
          show-action
          @input="inputParamSearch"
          @cancel="onCancel"
        />
        <div class="list">
          <van-radio-group v-model="radio" :disabled="ifCheck ? true : false">
            <van-cell-group>
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <van-cell
                  v-for="(item, i) in list"
                  :key="i"
                  clickable
                  @click="checkSelect(item)"
                >
                  <van-radio slot="right-icon" :name="item.country">{{item.country}}</van-radio>
                </van-cell>
              </van-list>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Popup,
  Search,
  RadioGroup,
  Radio,
  Field,
  List
} from 'vant';
export default {
  name: 'SwselectLaySearch',
  props: {
    isrequired: Boolean,
    fieldId: String,
    index: Number,
    labeltext: String,
    checkValue: String,
    value: String,
    tableName: String,
    errorMessage: String,
    ifCheck: Boolean, //是否弹框选择
    ifClear: Boolean, //是否清空
    cssType: String,
    uri: {
      type: String,
      // default: '/paraserver/sw/base/para/depParaList?paraName='
      default: '/userserver/user/prsn/register/getCountryCode?iddocType='
    },
    leftIcon: {
      type: String
    },
    tableList: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Array
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      show: false,
      param: '',
      fieldvalue: this.value,
      radio: this.checkValue,
      loadList: [],
      listInit: [],
      list: [],
      loading: false,
      finished: false,
      j: 0
    };
  },
  mounted: function() {
    this.getparam();
  },
  watch: {
    ifClear(val) {
      if (val) {
        this.clearAll();
      }
    },
    tableName() {
      this.getparam();
    },
    tableList(oldVal, newVal) {
      if (oldVal != newVal) {
        this.loadList = this.tableList;
        this.listInit = this.tableList;
        this.loading = false;
      }
    }
  },
  methods: {
    onLoad() {
      //     let j=0;
      for (let i = 0; i < 40; i++) {
        if (this.j < this.loadList.length) {
          this.list.push(this.loadList[this.j]);
          this.j++;
        }
      }
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.list.length >= this.loadList.length) {
        this.finished = true;
      }
    },
    getparam: function() {
      let tableNm = this.tableName || '';
      if (tableNm.trim() == '') {
        this.loadList = this.tableList;
        this.listInit = this.tableList;
        this.loading = false;
        return false;
      }
       let arr=[];
       this.$http.get(this.uri + tableNm).then(res => {

          // let countyData = res.data;
          arr = res[this.tableName]
          // for(let j in countyData){
          //  arr.push({code:countyData[j],country:j})
          // }

          this.loadList = arr;
          this.listInit = arr;
          this.loading = false;
          this.resultCode(arr);
        });

    },
    resultCode(arr) {
      let codeOld = this.radio;
      if (codeOld && !this.value) {
        let res = arr.filter(item => {
          return codeOld == item.country;
        });
        if (res && res.length > 0) {
          let item = res[0];
          this.fieldvalue = item.code;
          this.radio = item.country;
          this.show = false;
          item.fieldId = this.fieldId;
          item.index = this.index;
          this.$emit('selectObj', item);
        }
      }
    },
    showPopup() {
      if (!this.ifCheck) {
        this.show = true;
        let val = this.value;
        this.param = '';
        this.inputParamSearch('');
        if (val) {
          let itemArr = this.list.filter(item => {
            let name = item.country + '-' + val;
            return (
              val == item.country ||
              val == item.code ||
              name == item.code
            );
          });
          if (itemArr.length == 1) {
            let item = itemArr[0];
            this.radio = item.country;
          }
        }
      }
    },
    checkSelect(item) {
      if (!this.ifCheck) {
        this.fieldvalue = item.code;
        this.radio = item.country;
        this.show = false;
        item.fieldId = this.fieldId;
        item.index = this.index;
        this.$emit('selectObj', item);
      }
    },
    inputParamSearch(val) {
      if (val) {
        let listFifter = [],
          country = '',
          code = '';

        for (let index = 0; index < this.listInit.length; index++) {
          country = this.listInit[index].country;
          code = this.listInit[index].code;
          if (
            country &&
            code &&
            (country.indexOf(val) != -1 || code.indexOf(val) != -1)
          ) {
            listFifter.push(this.listInit[index]);
          }
        }
        this.loadList = listFifter;
      } else {
        this.loadList = this.listInit;
      }
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.j = 0;
      this.onLoad();
    },
    onCancel() {
      if (!this.ifCheck) {
        this.param = '';
        this.radio = '';
        this.$emit('selectObj', {
          country: '',
          code: '',
          fieldId: this.fieldId
        });
        this.show = false;
      }
    },
    clearAll() {
      this.param = '';
      this.fieldvalue = '';
      this.radio = '';
      this.show = false;
      this.$emit('selectObj', {
        country: '',
        code: '',
        fieldId: this.fieldId
      });
    },
    headBack() {
      this.show = false;
    }
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [List.name]: List
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/css/handle.scss';
.header_param {
  @include background('headerColor');
  @include padding('headerPadding');
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 0;
  .left {
    width: 65px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 15px;
    img {
      @include height('fontsize-title');
      margin-left: 8px;
    }
  }
  .center {
    flex: 1;
    // font-size: 16px;
    @include font-size('fontsize-title');
    display: flex;
    font-weight: bold;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 44px;
    // height: 44px;
  }
  .right {
    width: 65px;
    display: flex;
    @include font-size('fontsize-title');
    justify-content: flex-end;
    align-items: center;
    span {
      margin-right: 12px;
    }
  }
  &.white {
    background: #fff;
    border-bottom: 1px solid $lineColor;
    .left {
      color: $headerColor;
    }
    .center {
      color: $fontColor;
      font-weight: bold;
    }
    .right {
      color: $fontColor;
    }
  }
  .backArrow {
    left: 15px;
    // @include width('arrowSize');
    // @include height('arrowSize');
    // @include border-top('arrowBorder');
    // @include border-right('arrowBorder');
    transform: rotate(225deg);
    -webkit-transform: rotate(225deg);
    display: block;
    float: right;
    position: relative;
    // top: 13px;
  }
}
.searchInput {
  position: absolute;
  top: 44px;
  width: 100%;
}
.selectSearch {
  padding-top: 110px;
  height: calc(100% - 110px);
  .van-cell .van-field__value {
    -ms-flex: 0.95 !important;
    flex: 0.95 !important;
    -webkit-box-flex: 0.95 !important;
  }
  .van-radio__label {
    margin-left: 15px;
  }
  .van-radio__icon {
    font-size: 16px;
    margin-left: 10px;
  }
}
.list {
  height: 100%;
  overflow: auto;
  background: #f3f3f3;
}
</style>
